/**
 * Fixed toolbar wrapper.
 * Pass a color prop to change background.
 */
import styled from "styled-components";

export const StyledToolbar = styled.div`
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background: transparent; // Color dinámico
    z-index: 1000;
    box-sizing: border-box; // Evita que los paddings hagan que el contenido se salga
    max-width: 100vw; // Evita desbordamientos
    overflow: hidden;
`;